(ns net.kestec.mhda-pilgrimage.public.application.form.application-form-substep-documents
  (:require
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/Button" :default Button]
    ["@mui/material/Chip" :default Chip]
    ["@mui/material/Avatar" :default Avatar]
    ["@mui/material/FormHelperText" :default FormHelperText]
    ["@mui/icons-material/Delete" :default DeleteIcon]

    [net.kestec.mhda-pilgrimage.lib-ui.form-components :refer [grid-full]]
    [net.kestec.mhda-pilgrimage.lib-ui.form-uploads :as form-uploads]
    [net.kestec.mhda-pilgrimage.lib-ui.form-validator :refer [form-field-validator check-count check-combine-or]]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.public.application.application-events :as-alias application-events]
    [day8.re-frame.http-fx]
    [reagent.core :as r]
    [re-frame.core :as rf]
    ))



(def VALIDATOR
  {
   :nurse_documents {:check-fn (check-combine-or (fn [data]
                                                   (not
                                                     (or
                                                       (true? (:q_help_mobility_2km data))
                                                       (true? (:q_help_bed data))
                                                       (true? (:q_help_clothing data))
                                                       (true? (:q_help_hygiene data))
                                                       (true? (:q_help_feeding data))
                                                       (true? (:q_help_toilette data))
                                                       (true? (:q_chronic_illness data))
                                                       (true? (:q_help_medical data))
                                                       )))
                                                 (check-count 1)) :error-text "Bitte mindestens das Attest Dokument hochladen (Zusätzliche Dokumente sind möglich)" :missing-text "Pflegedokumente"}

   :med_documents   {:check-fn (check-combine-or (fn [data]
                                                   (not (or
                                                          (true? (:q_help_mobility_2km data))
                                                          (true? (:q_help_bed data))
                                                          (true? (:q_help_clothing data))
                                                          (true? (:q_help_hygiene data))
                                                          (true? (:q_help_feeding data))
                                                          (true? (:q_help_toilette data))
                                                          (true? (:q_chronic_illness data))
                                                          (true? (:q_help_medical data))
                                                          )))
                                                 (check-count 1)) :error-text "Bitte mindestens das Attest Dokument hochladen (Zusätzliche Dokumente sind möglich)" :missing-text "Arzt Attest"}
   })

(defn main []
  (let [!application (rf/subscribe [::db/get ::db/selected-application])
        field-validator (form-field-validator VALIDATOR !application)
        document-base-path (str "/api/pilgrimage/" (rf/subscribe [::db/get ::db/me :pilgrimage-id]) "/application/" (:id @!application) "/files/")
        ]

    (if (or
          (true? (:q_help_mobility_2km @!application))
          (true? (:q_help_bed @!application))
          (true? (:q_help_clothing @!application))
          (true? (:q_help_hygiene @!application))
          (true? (:q_help_feeding @!application))
          (true? (:q_help_toilette @!application))
          (true? (:q_chronic_illness @!application))
          (true? (:q_help_medical @!application))
          )
      [:<>
       [grid-full [:br]]
       [grid-full [:> Typography {:variant "p" :sx {:fontWeight "bold"}}
                   "Sie haben eine dieser Fragen mit JA beantwortet"]]
       [grid-full [:> Typography {:variant "p" :sx {:fontWeight "bold"}}
                   "daher benötigen wir bitte auch die ausgefüllte "
                   [:a {:target "_blank" :href "/documents/Malteser_Pflegeanamnese_2026_2_REISE_digi.pdf"} "Pflegeanamnese (Download)"]
                   " hier hochgeladen."
                   ]]



       ;[:pre (pr-str (:nurse_documents @!application))]
       (into [:<>]
             (for [doc (:nurse_documents @!application)]
               [grid-full [:> Chip
                           {:sx         {:backgroundColor "#1c1c2e" :color "white"}
                            :label      (or (:file_name doc) "Unknown")
                            ;:onClick    #(rf/dispatch [::application-events/remove-nurse-document (:file doc)])
                            :onDelete   #(rf/dispatch [::application-events/remove-nurse-document (:file doc)])
                            :deleteIcon (r/as-element [:> DeleteIcon {:style {:color "white"}}])
                            :avatar     (r/as-element [:> Avatar {:alt "Natacha" :src (str document-base-path (:file doc))}])
                            ;:avatar     (r/as-element [:> Avatar "PDF"])
                            }]]
               ))

       [grid-full
        [:br]
        [form-uploads/file-upload "Pflegeanamnese Dokumente hochladen"
         :multiple true
         :on-change [::application-events/store-nurse-documents]]]

       [grid-full
        ;[:pre (pr-str (field-validator :nurse_documents))]
        [:> FormHelperText {:error (:error (field-validator :nurse_documents))} (:helperText (field-validator :nurse_documents))]
        ]

;; #################################################################################

       [grid-full [:> Typography {:variant "p" :sx {:fontWeight "bold"}}
                   "weiters benötigen wir bitte auch das durch Ihren Arzt vollständig ausgefüllte "
                   [:br]
                   [:a {:target "_blank" :href "/documents/Malteser_aerztliches_Attest_2025_digital.pdf"} "Attest  (Download)"]
                   " hier hochgeladen. "
                   ]]

       ;[:pre (pr-str (:med_documents @!application))]
       (into [:<>]
             (for [doc (:med_documents @!application)]
               [grid-full [:> Chip
                           {:sx         {:backgroundColor "#1c1c2e" :color "white"}
                            :label      (or (:file_name doc) "Unknown")
                            ;:onClick    #(rf/dispatch [::application-events/remove-med-document (:file doc)])
                            :onDelete   #(rf/dispatch [::application-events/remove-med-document (:file doc)])
                            :deleteIcon (r/as-element [:> DeleteIcon {:style {:color "white"}}])
                            :avatar     (r/as-element [:> Avatar {:alt "Natacha" :src (str document-base-path (:file doc))}])
                            ;:avatar     (r/as-element [:> Avatar "PDF"])
                            }]]
               ))



       [grid-full
        [:br]
        [form-uploads/file-upload "Attest Dokumente hochladen"
         :multiple true
         :on-change [::application-events/store-med-documents]]]

       [grid-full
        ;[:pre (pr-str (field-validator :med_documents))]
        [:> FormHelperText {:error (:error (field-validator :med_documents))} (:helperText (field-validator :med_documents))]
        ]


       ]
      [:<>

       ;[:pre (pr-str (:med_documents @!application))]
       (into [:<>]
             (for [doc (:med_documents @!application)]
               [grid-full [:> Chip
                           {:sx         {:backgroundColor "#1c1c2e" :color "white"}
                            :label      (or (:file_name doc) "Unknown")
                            ;:onClick    #(rf/dispatch [::application-events/remove-med-document (:file doc)])
                            :onDelete   #(rf/dispatch [::application-events/remove-med-document (:file doc)])
                            :deleteIcon (r/as-element [:> DeleteIcon {:style {:color "white"}}])
                            :avatar     (r/as-element [:> Avatar {:alt "Natacha" :src (str document-base-path (:file doc))}])
                            ;:avatar     (r/as-element [:> Avatar "PDF"])
                            }]]
               ))

       [grid-full
        [:br]
        [form-uploads/file-upload "Optional Attest Dokumente hochladen"
         :multiple true
         :on-change [::application-events/store-med-documents]]]

       ])))